export const ATTACHMENT_MAX_SIZE_MB = 10

export const ATTACHMENT_ALLOWED_EXTENSIONS = [
  "png",
  "jpeg",
  "jpg",
  "pdf",
  "doc",
  "docx"
]

export const ATTACHMENT_ACCEPT = ATTACHMENT_ALLOWED_EXTENSIONS.map(
  (ext) => `.${ext}`
).join(",")
